import { clsx } from "clsx";
import CheckIcon from "../check-icon.tsx";
import classes from "./barrier-button.module.css";

type BarrierButtonProps = {
	readonly barrierLabel: string;
	readonly barrierComplete: boolean;
	readonly barrierCommandfor: string;
	readonly barrierCommand: string;
	readonly label: string;
	readonly onClick: () => void;
};

function BarrierButton({
	barrierLabel,
	barrierComplete,
	barrierCommandfor,
	barrierCommand,
	label,
	onClick,
}: BarrierButtonProps) {
	return (
		<div className={classes["barrier-button"]}>
			<button
				type="button"
				commandfor={barrierCommandfor}
				command={barrierCommand}
				className={clsx(
					classes["individual-button"],
					barrierComplete && classes["individual-button-complete"],
				)}
			>
				<div className={classes["individual-icon"]}>
					<CheckIcon size={14} />
				</div>
				{barrierLabel}
			</button>
			<button
				type="button"
				onClick={onClick}
				className={clsx(classes["individual-button"])}
				disabled={!barrierComplete}
			>
				<div className={classes["individual-icon"]}>
					<CheckIcon size={14} />
				</div>
				{label}
			</button>
		</div>
	);
}

export default BarrierButton;
